import { render, staticRenderFns } from "./iconP2.vue?vue&type=template&id=575eb4fa&scoped=true&"
import script from "./iconP2.vue?vue&type=script&lang=js&"
export * from "./iconP2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575eb4fa",
  null
  
)

export default component.exports